import React, { Component } from 'react';
import store from '~/redux/user/store';
import { checkPassword, setParentalControls, updatePin, updateRating, refresh, getMySubscription } from '~/redux/user/actions';
import Spinner from '~/components/Spinner';
import './style.scss'
import userStore from '~/redux/user/store'
import popup from '~/views/Popup/popup';
import { fbLogin } from '~/redux/user/actions'
import { get, find } from 'lodash'
import socialHelpers from '../socialHelpers'
import { getLocalizedVal } from '~/tools/localization/helpers'
import { getUserPin } from '~/tools/isPinSet';
import { axios } from "~/axios"

class SetupPin extends Component {
    constructor(props){
        super(props)
        this.state = {
            error: '',
            pins: '',
            user_password: '',
            pinSetupSuccess: '',
            metaDataMap: {},
            processing: false,
            isPinExist: getUserPin() || false
        }
        this.pinBoxes = [1, 2, 3, 4];
        this.pinsRef = [];
        this.isOTPEnabled = get(window.settings, 'features.otp_value.otp_enabled');

    }
    componentDidMount(){
        socialHelpers.initializeFacebookLogin()

    }
    getVal(key){
        return get(this.state.metaDataMap, key)
    }

    shouldDisableLogin() {
        if (this.state.buttonProgress)
          return true
    
        return false
    }

    handlePassword = (event) => {
        const { name, value } = event.target;
        this.setState({[name]: value});
    }

    handleState = (event, nextFieldID) => {
        
        const { name, value } = event.target;

        if (Number(event.target.value) > 0) {
            
            this.setState({[name]: value});
            this.isPrevBoxEmpty(event, value, nextFieldID);

        } else {
            this.setState({[name]: ''});
            this.isPrevBoxEmpty(event, '', nextFieldID);
        }
    }

    isPrevBoxEmpty = async (event, fieldValue, nextFieldID) => {
        let boxCountFlag = 0;
        let isBoxNotEmptyFlag = true;
        let nextMoveBox = nextFieldID;

        const numberOfPinBoxes = this.pinBoxes && this.pinBoxes.length;
        const currentBoxId = nextFieldID -1;
        const getBoxes = currentBoxId > numberOfPinBoxes ? numberOfPinBoxes : 0;

        for( let boxId = (4 + getBoxes); boxId >=  (1 + getBoxes); boxId--) {
            const prevBoxId = boxId - 1;
            const postBoxId = boxId + 1;

            if((document.getElementById(boxId) && document.getElementById(boxId).value) &&  (prevBoxId != 4 && document.getElementById(prevBoxId) && !document.getElementById(prevBoxId).value)) {
                document.getElementById(prevBoxId).value = document.getElementById(boxId).value;
                document.getElementById(boxId).value = '';
                document.getElementById(boxId).focus();
                isBoxNotEmptyFlag = false;
                nextMoveBox = boxId;
            } else if(!document.getElementById(boxId).value && ( postBoxId != 5 && document.getElementById(postBoxId) && document.getElementById(postBoxId).value)) {
                document.getElementById(boxId).value = document.getElementById(postBoxId).value;
                document.getElementById(postBoxId).value = '';
                document.getElementById(postBoxId).focus();
                isBoxNotEmptyFlag = false;
                nextMoveBox = boxId + 1;
            } else if(fieldValue && document.getElementById(boxId).value && nextFieldID < (3 + getBoxes) ) {
                document.getElementById(nextMoveBox).focus();
            }
            boxCountFlag++;
        }

        if(fieldValue && isBoxNotEmptyFlag && boxCountFlag == 4) {
            this.moveOnMax(event, fieldValue, nextFieldID)
        }
    }

    moveOnMax = (event, fieldValue, nextFieldID) => {
        if (fieldValue && fieldValue.length === 1 && nextFieldID <= 5) {
            nextFieldID < 5 && document.getElementById(nextFieldID).focus();
            
            if (nextFieldID <= 5) {
                this.combinedPins(this.pinsRef, 'pins');
            }
            
            if(this.props.user.provider === 'viewlift' && nextFieldID === 5) {
                
                if(this.checkOTPEnabled() || (this.getProvider() == 'google') || (this.getProvider() === 'facebook')) {
                    return true;
                } else {
                    !this.isDisplayPasswordField() ? this.setPin(event) : document.getElementById('user_password').focus();
                }
                return true; 
            }

            if(this.props.user.provider === 'google' && nextFieldID === 5) {
                this.setPin(event)
            }
        } 
    }
    
    combinedPins = async (pinsRef, pinState) => {
        const videoPins = [];

        await pinsRef && pinsRef.length > 0 &&  pinsRef.map((refItem) => {
            videoPins.push(refItem.value);

            if (videoPins && videoPins.length === 4 ) {
                const videoPinString = videoPins.join("")

                if (pinState === 'pins') {
                    this.setState({ pins: videoPinString})
                } 
            }
        })
    }

    saveViewingRestriction = async (userRating) => {
        await setParentalControls(userRating)
        .then(response => { 
            if (response && response.status === 200) {
                store.dispatch(updateRating(this.props.args.rating.rating))
                this.setState({ processing: false})
                popup.hide()
            } else {
                this.alert(getLocalizedVal(window.settings,'genericMessages','unableSetPin') || 'Unable to set the PIN' || response.data.error);
                return false;
            }
        })
    }

    closePopup = () => {
        setTimeout(()=>{ !getUserPin() ? window.location= '/user' : popup.hide() }, 1000)
    }

    setPin = async (event) => {
        await event.preventDefault();
        
        const pattern =  /[0-9]{4}/g;
    
        if (!this.state.pins || this.state.pins.length < 4) {
            this.alert(getLocalizedVal(window.settings,'genericMessages','validPinError') || 'Enter valid PIN');
            return false;
        } else if ((pattern.test(this.state.pins) === false)) {
            this.alert(getLocalizedVal(window.settings,'genericMessages','validPinError') || 'Enter valid PIN');
            return false;
        } else {   
            this.setState({ processing: true });        
            const parentalPin = { 'parentalPin': this.state.pins };
            setParentalControls(parentalPin)
            .then(pinSetRes => { 
                if (pinSetRes && pinSetRes.status === 200) {
                    if(this.props && this.props.args && this.props.args.rating && this.props.args.rating.rating) {
                        let userRating = {
                            "parentalRating": this.props.args.rating.rating
                        }
                        this.saveViewingRestriction(userRating);
                    }
                    store.dispatch(updatePin(this.state.pins))
                    this.setState({ processing: false, pinSetupSuccess: true})
                } else {
                    this.setState({ processing: false });
                    this.alert(pinSetRes.data.error || getLocalizedVal(window.settings,'genericMessages','errorOccurredMessage') || "An error occurred");
                    return false;
                }
            })
            .catch(error => {
                this.setState({ processing: false });
                console.error(error);
            })

            return false;
        }
    }


    handleSubmit = async (event) => {
        await event.preventDefault()
        const pattern =  /[0-9]{4}/g;	
        if (!this.state.pins || this.state.pins.length < 4) {
            this.alert(getLocalizedVal(window.settings,'genericMessages','validPinError') || 'Enter valid PIN');
            return false;
        } else if ((pattern.test(this.state.pins) === false)) {
            this.alert(getLocalizedVal(window.settings,'genericMessages','validPinError') || 'Enter valid PIN');
            return false;
        } else if(!this.state.user_password || this.state.user_password.length < 4) {
            this.alert(getLocalizedVal(window.settings,'genericMessages','enterCorrectPassword') || 'Enter correct password');
            return false;
        } else {    
            this.setState({ processing: true });
            const user = store.getState().user;

            var checkPasswordCreds = {
                email: user && user.email,
                password: this.state.user_password
            }
            
            checkPassword(checkPasswordCreds)
            .then(passwordRes => {
                if (passwordRes && passwordRes.status === 200) {
                    const parentalPin = { 'parentalPin': this.state.pins };
                    setParentalControls(parentalPin)
                    .then(pinSetRes => { 
                        if (pinSetRes && pinSetRes.status === 200) {
                            if(this.props && this.props.args && this.props.args.rating && this.props.args.rating.rating) {
                                let userRating = {
                                    "parentalRating": this.props.args.rating.rating
                                }
                                this.saveViewingRestriction(userRating);
                            }
                            store.dispatch(updatePin(this.state.pins))
                            this.setState({ processing: false, pinSetupSuccess: true})
                        } else {
                            this.setState({ processing: false });
                            this.alert(pinSetRes.data.error || getLocalizedVal(window.settings,'genericMessages','errorOccurredMessage') || "An error occurred");
                            return false;
                        }
                    })
                    .catch(error => {
                        this.setState({ processing: false });
                        console.error(error);
                    })

                    return false;
                } else {
                    this.setState({ processing: false });
                    this.alert(getLocalizedVal(window.settings,'genericMessages','enterCorrectPassword') || 'Enter correct password' || passwordRes.data.error);
                    return false;
                }  
            })
        }
    }
    handleOtp = async (event) => {
        event.preventDefault();
        if (this.isOTPEnabled && this.state.pins && this.state.pins.length === 4 && this.props && this.props.user && this.props.user.phoneNumber) {
            this.setState({processing: true})
            let user = {}
            const { phoneNumber } = this.props.user;
            user["phoneNumber"] = phoneNumber
            user["screenName"] = "parentalControl"
            user["parentalPin"] = this.state.pins
            await axios({
                method: 'POST',
                url: `${window.settings.apiBaseUrl}/identity/otp/resend`,
                params: {
                  site: window.settings.internalName
                },
                data: {phoneNumber},
                headers: {
                  'x-api-key': window.settings.baseAPIKey
                }
              }).then( () => {popup.verifyOTPScreen(user, this.state.metaDataMap)})
        } else {
            this.alert(getLocalizedVal(window.settings,'genericMessages','validPinError') || 'Enter valid PIN');
        }
    }
    facebookLogin(e) {
        if (this.state.pins && this.state.pins.length === 4) {
            this.setState({ processing: true })
            const element = document.getElementById('ageCheck')
            if (element) {
                const ageCheck = element.checked
                if (!ageCheck) {
                    this.setState({ ageCheckError: window.settings.features.legal_verbiage_error })
                    return
                }
            }
            window.FB.login(res => {
                var accessToken = res && res.authResponse && res.authResponse.accessToken
                if (!accessToken)
                    return this.alert(this.getVal('facebookError'))
                this.dispatchLogin(fbLogin({
                    facebookToken: accessToken,
                    emailConsent: (this.state.activeTab === 'signup' && this.state.emailConsent.visible) ? this.state.emailChecked : undefined
                }), 'Facebook')
            }, { auth_type: 'reauthenticate' })
        } else {
            this.alert(getLocalizedVal(window.settings,'genericMessages','validPinError') || 'Enter valid PIN');
        }
    }
      dispatchLogin(act, loginType) {
        if(this.props.onInitiate){ this.props.onInitiate('login') }
        userStore
          .dispatch(act)
          .then( _ => {
            this.props.user.isSubscribed ? userStore.dispatch(getMySubscription()).then(() => {
                userStore.dispatch(refresh()).then(() => {
                    const parentalPin = { 'parentalPin': this.state.pins };
                            setParentalControls(parentalPin)
                            .then(pinSetRes => { 
                                if (pinSetRes && pinSetRes.status === 200) {
                                    store.dispatch(updatePin(this.state.pins))
                                    this.setState({ pinSetupSuccess: true})
                                } else {
                                    this.alert(pinSetRes.data.error || getLocalizedVal(window.settings,'genericMessages','errorOccurredMessage') || "An error occurred");
                                    return false;
                                }
                            })
                    this.setState({ buttonProgress: false })
                        }) 
            }) : userStore.dispatch(refresh()).then(() => {
                const parentalPin = { 'parentalPin': this.state.pins };
                        setParentalControls(parentalPin)
                        .then(pinSetRes => { 
                            if (pinSetRes && pinSetRes.status === 200) {
                                store.dispatch(updatePin(this.state.pins))
                                this.setState({ pinSetupSuccess: true})
                            } else {
                                this.alert(pinSetRes.data.error || getLocalizedVal(window.settings,'genericMessages','errorOccurredMessage') || "An error occurred");
                                return false;
                            }
                        })
                this.setState({ buttonProgress: false })
                    }) 
            
          })
          .catch( error => {
            var errorCode = ""
            this.setState({ buttonProgress: false })
            if(error.response && error.response.data) {
              errorCode = error.response.data.code
            }
            var message = this.getVal(errorCode) || this.getVal('defaultError') ;
            this.alert(message)
            if(this.props.onAuthenticate){ this.props.onAuthenticate(false, message) }
          })
      }

    getProvider = () => {
        const { provider } = this.props.user;
    
        if(provider) {
            return provider
        } else {
            return false
        }
    }
    
    checkOTPEnabled = () => {
        if((window.settings && window.settings.features && window.settings.features.otp_value && window.settings.features.otp_value.otp_enabled && this.props.user.phoneNumber)) {
            return true
        } else {
            return false
        }
    }


    isDisplayPasswordField = () => {

        if((this.checkOTPEnabled()) ||  (this.getProvider() == 'google') || (this.getProvider() === 'facebook')) {
            return false
        } else if(!getUserPin()) {
            return false
        } else {
            return true
        }
    }

    alert(msg) {
        this.setState({ error: msg })
        setTimeout(_ => this.setState({ error: null }), 5000)
    }
    
    render() {
        const localizedArgs = this.props && this.props.args && this.props.args.localizedFields && this.props.args.localizedFields.args;
        const { provider } = this.props.user;
        if (this.state.pinSetupSuccess) {
            return (
                <div className="centered padded">
                <h2>{getLocalizedVal(window.settings,'genericMessages','pinSetSuccess') || 'Pin has been setup successfully.'}</h2>
                { this.closePopup() }
                </div>
            )
        }

        return (
            <div className="centered padded">
                {this.state.error && <div className="error padding-bottom-20" >{this.state.error}</div>}
                { this.state.isPinExist ? (<h3>{localizedArgs && localizedArgs.enterNewPinLabel || "ENTER NEW PIN"}</h3>) : (<h3>{localizedArgs && localizedArgs.enterPinLabel || "ENTER PIN"}</h3>)}
                <div className="set-pin">
                    {this.pinBoxes && this.pinBoxes.map((index)=>{
                        const autoFocusTxt = index === 1 ? true: false;
                        return (<input className="input" key={index} type="password" id={index} ref={(refItem) => this.pinsRef[index] = refItem} onKeyUp={(event) =>  this.handleState(event, index+1)} maxlength="1" autoComplete="false" autoFocus = {autoFocusTxt}
                        required/>)
                    })}
                </div>
                {this.state.processing && <div className="loading-centered"><Spinner /></div>}
                {provider === 'facebook' && 
                    <div>
                        <div className="social-logins">
                            <div className="social-buttons">
                                <button
                                    disabled={this.state.processing}
                                    className="facebook-color-background button fat"
                                    onClick={e => this.facebookLogin(e)}
                                >{(localizedArgs && localizedArgs.authWithFacebook) || 'Authenticate With Facebook'}
                                </button>
                            </div>
                        </div>
                    </div> }
                    { this.checkOTPEnabled() && provider !== 'facebook' && this.props.user.phoneNumber &&
                    <div>
                        <div>
                            <button 
                            disabled={this.state.processing}
                            className="button fat cta"
                            onClick={(event) => this.handleOtp(event)}
                            >{(localizedArgs && localizedArgs.authWithOTP) || 'Authenticate With OTP'}</button>
                        </div>
                    </div>
                    }
                    { this.isDisplayPasswordField() &&
                    <div className="pinButtons">
                        <h3>{(localizedArgs && localizedArgs.enterPasswordLabel) || "ENTER PASSWORD"}</h3>
                        <div>
                            <input className="input-width" type="password" id="user_password" name="user_password" onChange={event => this.handlePassword(event)} placeholder="" required />
                        </div>

                        <div>
                            <input className={`input cta` + (this.state.processing ? ' processing' : '')} type="submit" value={(localizedArgs && localizedArgs.saveRatingCTA) || "SAVE"} onClick={(event) => this.handleSubmit(event)} />
                        </div>
                    </div>
                }
            </div>

        );
    }
}

export default SetupPin;
